
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqV7vP9MUJwKIqNHh3sa7UtH8SbHOHawnRqMSA_KQHt44Meta } from "/codebuild/output/src2143366936/src/src/pages/faq.vue?macro=true";
import { default as menuHAlCwjdf8bF4M8MQHswiUclH1HwkfrZHuU4J2BxCWpoMeta } from "/codebuild/output/src2143366936/src/src/pages/menu.vue?macro=true";
import { default as index1UVKc_45WacIS_2uayr63VLyC2lw4JjUTI6Rr7QmHlp9AMeta } from "/codebuild/output/src2143366936/src/src/pages/index.vue?macro=true";
import { default as contactD9tgMbo6HyP79G8u_GgLAM5YKJChrzJ5ezYSx6rokhEMeta } from "/codebuild/output/src2143366936/src/src/pages/contact.vue?macro=true";
import { default as tutorialEhLzQhaifu5VwPgvqmoUR2n1W92HGgesYqQZywYTeLYMeta } from "/codebuild/output/src2143366936/src/src/pages/tutorial.vue?macro=true";
import { default as agreementEHA3AImx9t43usREgmk8AwgG062jBmvJiFsmg13bkKcMeta } from "/codebuild/output/src2143366936/src/src/pages/agreement.vue?macro=true";
import { default as about_45passob_npRd0jtVgYx9cTX8iKkEVhmWR6KXt8cIU_tTGGToMeta } from "/codebuild/output/src2143366936/src/src/pages/about-pass.vue?macro=true";
import { default as indexVNWXKePwcjSrU_BICUHI7VXYBGuUrRxp1Py1ogM829YMeta } from "/codebuild/output/src2143366936/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93ufk_45qw2yrmycRL4FsrWwh0MRiSyzGiogKjZutc4GISkMeta } from "/codebuild/output/src2143366936/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceSChhAIOyPgLtQ_hdGhAnaIBNZx6_45zcWxfboS6onnDLgMeta } from "/codebuild/output/src2143366936/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93bo7W8IUrIR5sMNPHr_45Lb6oTh5hNeJtGRl7sMRzWsh8EMeta } from "/codebuild/output/src2143366936/src/src/pages/notice/[id].vue?macro=true";
import { default as index_PEjmdCldaICNnviMLlXEPpQ8yW29axjMpvQq3DARJ4Meta } from "/codebuild/output/src2143366936/src/src/pages/coupon/index.vue?macro=true";
import { default as index5y6LH_45cZRit5QOXeDbmie_VitF6MrXbYmgijjEJomGYMeta } from "/codebuild/output/src2143366936/src/src/pages/mypage/index.vue?macro=true";
import { default as indexDYnsZdF607oK5KFehnk_H_45swj1LNoJ0_45ERQMQkLyk1QMeta } from "/codebuild/output/src2143366936/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93ZVKz4Fz8qzuDHCRS7qFvsyXm7SZs_H7ZnOf9IF1iwfEMeta } from "/codebuild/output/src2143366936/src/src/pages/parking/[id].vue?macro=true";
import { default as indexBzCei8kMQZomiwK2Im2dCu7exwprbSI0WX07g7TgKOAMeta } from "/codebuild/output/src2143366936/src/src/pages/history/index.vue?macro=true";
import { default as indexDvhv2sNjdYp2y0Ek7KhgL3Zx60bqHNTq4befR3P0t_45YMeta } from "/codebuild/output/src2143366936/src/src/pages/monthly/index.vue?macro=true";
import { default as index0_uEHb2ZCQSU2VDEwSdD8CV68pHdMwvOG727QB9axd8Meta } from "/codebuild/output/src2143366936/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexz2gjxNvSQozfYLlmno_TLszfe0Xey9wu7__cCxVkLXgMeta } from "/codebuild/output/src2143366936/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviJZDSn4ufD9aqcZSYUk8AIgsOtBDa7sXGul3VJKb8AckMeta } from "/codebuild/output/src2143366936/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editvNHf5bbW6lXbCUb6YUD17_1Lkqcv_45xs1yEHvywnO_FYMeta } from "/codebuild/output/src2143366936/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementlgq7to6ed33Gma0JVyp_ZQqYPxeb80deo4rphyVcfAIMeta } from "/codebuild/output/src2143366936/src/src/pages/pass-agreement.vue?macro=true";
import { default as index2j50WS08z4N6TARulrckG1AcByYpbBWjRTbKR9AwAasMeta } from "/codebuild/output/src2143366936/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dP3mLcaid5XN8SORSA5WMa2s0E3rChlZQWB6WFfEEMssMeta } from "/codebuild/output/src2143366936/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm3CPERdeSVwZ7mTwR4eeM_45eeHHJrsh2ot69qs9bqW2OsMeta } from "/codebuild/output/src2143366936/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexecy4BYdY5vwnTlXIEpzAHJpTcRb0wthyFH4qPOY1_IcMeta } from "/codebuild/output/src2143366936/src/src/pages/card/create/index.vue?macro=true";
import { default as indexmFutmo7JOlks8gYAhJJRkaxdPsols0a_45PZerVn7oxLwMeta } from "/codebuild/output/src2143366936/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmdS3hLeBk_09CwvLidOuqjXyomn9CwSO_OIpdgSXIvr4Meta } from "/codebuild/output/src2143366936/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirm3b4ob2UVaybx2OBzIEaMhQAQppsFZcxy0mt9SRw8ZCwMeta } from "/codebuild/output/src2143366936/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeIPC9M9mwF9Hhre4V0eG7807m_9vQubXyxOa_45yrGujzEMeta } from "/codebuild/output/src2143366936/src/src/pages/membership/complete.vue?macro=true";
import { default as registeroAPmwaEbWkRRalq3jbxTw4aogj0hRT79_45qJSgtu0x8wMeta } from "/codebuild/output/src2143366936/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93c9gd6WzKXZPuk81vccoIQw5tyhliiOkF4WoBsA0MkxUMeta } from "/codebuild/output/src2143366936/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmA7NICgDYR_45CIiXnFkBmhwk_45_N9sVsgItqf6FLgQXrwwMeta } from "/codebuild/output/src2143366936/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93OFzPm2MgBr58iFr4_7NCxomNMZC4bMb6QXrmU4VE3JUMeta } from "/codebuild/output/src2143366936/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexU5Z5VB8HR6U6RJF9HUkvSpj1Rp3dUgMhHX5_lTl3V_0Meta } from "/codebuild/output/src2143366936/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeBGfRq8jZMYhKT8cEPeUxkPOvq9z_45OOoXznjs5TQvQEEMeta } from "/codebuild/output/src2143366936/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codekIK8WU94X5vv12r3yuqv0nRE2hQ8N389rUdRNIhcOlwMeta } from "/codebuild/output/src2143366936/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeuQsRXA9fJ_Ggx9B3_e2jWPK5KuVRtnpSZKg9bQmrte4Meta } from "/codebuild/output/src2143366936/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerd8LNUELUrXxcOo7P0qS5M8DTzc9UV_VmQQ8Xas_451teQMeta } from "/codebuild/output/src2143366936/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeGEhoVlIHGymfCKTgc5t9qzcNyonNNZ_455LrSTChoNHygMeta } from "/codebuild/output/src2143366936/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as index7BQlSyxPCl9NPULVDs09okqZeLhJeu1deDhckC7MBJ4Meta } from "/codebuild/output/src2143366936/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmz6F3zXZR52CP3LgrMzRrvX5Xj2VKoQWSdQ2iFFc_mX4Meta } from "/codebuild/output/src2143366936/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completexs6FOHDtCNnTIH71uVOMDznhwLl6sgIgczNOsKS8NmsMeta } from "/codebuild/output/src2143366936/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexkqz_DieL_450kN6LtYKz_45PL1FsACewere36BQDJw0UMScMeta } from "/codebuild/output/src2143366936/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93JIwxLnzwF6aG00BFygq5RvJ_45ogYvvkvDC55bQZb5H3AMeta } from "/codebuild/output/src2143366936/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completepAcfLjX8Q9vIBdrQw4tZduhrzvWKKbtluXokK5eOL1IMeta } from "/codebuild/output/src2143366936/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasQgXtJnGJqSY1ZeENexgmc6GiS8fHJSSfmjxURrci0eYMeta } from "/codebuild/output/src2143366936/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleS5gCJ55i_45kqLXuuZEjrcZZNhjlFDmn1553dHCoepZ5oMeta } from "/codebuild/output/src2143366936/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailQxo8gHDgk79TGIudbX9pt5vL63u9MhdPMKN7At4db30Meta } from "/codebuild/output/src2143366936/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmdkTXRcIE_v_45ndfOA0lqOqJK6gySGgyTV4_45g_454QAQZNsMeta } from "/codebuild/output/src2143366936/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentEBXzXfMSeT_45tdLcrwNglhVyZ_453TDODSrZ4ACfhcClV8Meta } from "/codebuild/output/src2143366936/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirm10tAA7v_s5iM2VvRAzdUpv8lDwMSEGT6itz_UlmjgU4Meta } from "/codebuild/output/src2143366936/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateDG_lnFBAIYO_45ms01Ud9lCErfpUquo4JWurl6q8Ou678Meta } from "/codebuild/output/src2143366936/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeuFg_ZvWIkqns1ZEbi87tfcQodouV7ZTPZJZaEllwU6cMeta } from "/codebuild/output/src2143366936/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeB1IUItzqkp44hA8NTYOhGy1BiUc8PStCGDMMkuX29qIMeta } from "/codebuild/output/src2143366936/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordgJMD3M373t7mgq_45kH9y2C3dZBZeaM9rjSVIB3uGEk10Meta } from "/codebuild/output/src2143366936/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasVPNy3KcmoNfErlJJs3_xtk384Enb2KH4elMhXJ5MGq8Meta } from "/codebuild/output/src2143366936/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registeroBinB4icKkM09vN_45BjSE2JcLlkIos8E_uY2fG4TLLEoMeta } from "/codebuild/output/src2143366936/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code3RxeCkvuUggAELlLtdLSqgrVRMvf0Sszxr2JVI9DaMAMeta } from "/codebuild/output/src2143366936/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexltD8jMf6wES4vmgeUWby13aeYk2nls3IPK4l1zNaI6IMeta } from "/codebuild/output/src2143366936/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as index_45YokZTIWPrM7Nfa7Q5kDbcb62MonlPIgQaOIXmyJthYMeta } from "/codebuild/output/src2143366936/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexQY3DldOAkkf06Cn34CZK4aa2ktDbf883qDB45lc3kpIMeta } from "/codebuild/output/src2143366936/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexNqXtzcobvCgdYqcOi5RQp0RKXGnwT91SRA0CFM_451e7UMeta } from "/codebuild/output/src2143366936/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatexR_451Cobgnc4Lk2KfgGhGIinZp01cSTKKP4gEWjwDHQ4Meta } from "/codebuild/output/src2143366936/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completewnka0sR4nbEdCQVbY6MeWaXUOPuaXIKhizdXssXOe9YMeta } from "/codebuild/output/src2143366936/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmDXAN9keOX3BZT4skxH6NRPTPHJRfyl5bpA7HBoCIHb8Meta } from "/codebuild/output/src2143366936/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexPa7EB9PH47hRmw7lJiUh0yJRwDnsotKOUTB_rClyYukMeta } from "/codebuild/output/src2143366936/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete1FCDDEoPhuOntBR0AiW33OZ26UrhXAyQVf3oAAC0ZFMMeta } from "/codebuild/output/src2143366936/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateemb1dgGNB0mP0ODOgQ73U2lFBbbnpxQYu_45VFuppZnCUMeta } from "/codebuild/output/src2143366936/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index89vwVuNDrg0MwoqPRTcDbBijc0iKwXdM1RpqlgRK6MsMeta } from "/codebuild/output/src2143366936/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexUoL_45dhgd8XCN4Yhpj3MTpaNH2_45FVzexbHejtfP728SQMeta } from "/codebuild/output/src2143366936/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeqH5oHARZ2up36ui0yzdkRoEZ6ARolk__pgYo6CGxqf8Meta } from "/codebuild/output/src2143366936/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexvunCj7q7rrTcLLAMIp7j72_3Kze19B0pZ3vbodJFEzYMeta } from "/codebuild/output/src2143366936/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code6NMd7eunVL0mQH7THUc68yAdAl3Ftw3bnbThZtKN9pkMeta } from "/codebuild/output/src2143366936/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexu6mO4_D97mDWnQD0Gz2ZZNsaHVEQ5CNMIbO5GH5AdTEMeta } from "/codebuild/output/src2143366936/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexPBfiNF5cmMAcG9ZK3whCW0miG8teqdMEqTNSgDCBW3MMeta } from "/codebuild/output/src2143366936/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as index0dldYkiwQwCS5H26mZyUQAvGRkjNGihftK4_4dtHs_AMeta } from "/codebuild/output/src2143366936/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatekhTCAye0TJxHX3FW_82nzhXl7roq7sdO0BLXVgxuTE4Meta } from "/codebuild/output/src2143366936/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm6nCZ7DNcXDug3BVazK1seYmQo75ZHVSMEJzxoXJFYAEMeta } from "/codebuild/output/src2143366936/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuHAlCwjdf8bF4M8MQHswiUclH1HwkfrZHuU4J2BxCWpoMeta || {},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(index1UVKc_45WacIS_2uayr63VLyC2lw4JjUTI6Rr7QmHlp9AMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src2143366936/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index_PEjmdCldaICNnviMLlXEPpQ8yW29axjMpvQq3DARJ4Meta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2143366936/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexBzCei8kMQZomiwK2Im2dCu7exwprbSI0WX07g7TgKOAMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2143366936/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: index0_uEHb2ZCQSU2VDEwSdD8CV68pHdMwvOG727QB9axd8Meta || {},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexz2gjxNvSQozfYLlmno_TLszfe0Xey9wu7__cCxVkLXgMeta || {},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexecy4BYdY5vwnTlXIEpzAHJpTcRb0wthyFH4qPOY1_IcMeta || {},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmdS3hLeBk_09CwvLidOuqjXyomn9CwSO_OIpdgSXIvr4Meta || {},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirm3b4ob2UVaybx2OBzIEaMhQAQppsFZcxy0mt9SRw8ZCwMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2143366936/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeIPC9M9mwF9Hhre4V0eG7807m_9vQubXyxOa_45yrGujzEMeta || {},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registeroAPmwaEbWkRRalq3jbxTw4aogj0hRT79_45qJSgtu0x8wMeta || {},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmA7NICgDYR_45CIiXnFkBmhwk_45_N9sVsgItqf6FLgQXrwwMeta || {},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeBGfRq8jZMYhKT8cEPeUxkPOvq9z_45OOoXznjs5TQvQEEMeta || {},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codekIK8WU94X5vv12r3yuqv0nRE2hQ8N389rUdRNIhcOlwMeta || {},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeuQsRXA9fJ_Ggx9B3_e2jWPK5KuVRtnpSZKg9bQmrte4Meta || {},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerd8LNUELUrXxcOo7P0qS5M8DTzc9UV_VmQQ8Xas_451teQMeta || {},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmz6F3zXZR52CP3LgrMzRrvX5Xj2VKoQWSdQ2iFFc_mX4Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completexs6FOHDtCNnTIH71uVOMDznhwLl6sgIgczNOsKS8NmsMeta || {},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexkqz_DieL_450kN6LtYKz_45PL1FsACewere36BQDJw0UMScMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completepAcfLjX8Q9vIBdrQw4tZduhrzvWKKbtluXokK5eOL1IMeta || {},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleS5gCJ55i_45kqLXuuZEjrcZZNhjlFDmn1553dHCoepZ5oMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailQxo8gHDgk79TGIudbX9pt5vL63u9MhdPMKN7At4db30Meta || {},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmdkTXRcIE_v_45ndfOA0lqOqJK6gySGgyTV4_45g_454QAQZNsMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentEBXzXfMSeT_45tdLcrwNglhVyZ_453TDODSrZ4ACfhcClV8Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirm10tAA7v_s5iM2VvRAzdUpv8lDwMSEGT6itz_UlmjgU4Meta || {},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeuFg_ZvWIkqns1ZEbi87tfcQodouV7ZTPZJZaEllwU6cMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeB1IUItzqkp44hA8NTYOhGy1BiUc8PStCGDMMkuX29qIMeta || {},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordgJMD3M373t7mgq_45kH9y2C3dZBZeaM9rjSVIB3uGEk10Meta || {},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registeroBinB4icKkM09vN_45BjSE2JcLlkIos8E_uY2fG4TLLEoMeta || {},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code3RxeCkvuUggAELlLtdLSqgrVRMvf0Sszxr2JVI9DaMAMeta || {},
    component: () => import("/codebuild/output/src2143366936/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2143366936/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]